import { apiSections }                                     from "dmpconnectjsapp-base/constants";
import { getConfigurationValue, getDmpParameterFromState } from "dmpconnectjsapp-base/helpers/accessors";
import { isReady }                                         from "dmpconnectjsapp-base/helpers/common";
import { authenticationTypes, getAccessRightsProps }       from "dmpconnectjsapp-base/rules/accessRights";
import moment                                              from "moment";
import { dmpStatuses, userAuthorizationStatuses }          from "../../constants";
import { getPatientFromAccessibleDMPsCache }               from "../accessibleDMPList";
import { fixQualifIdentityOid, getInsTypeFromNir }         from "../certifiedIdentity";
import { extractPatientInfoFromIdentity }                  from "../insi";

export const isTreatingPhysician = directAuthenticationDMPStatus => directAuthenticationDMPStatus.i_treatingPhysician === 1;

export const isWebAccessOpen = (directAuthenticationDMPStatus) => {
  const { ExistingTestAnswer: { i_webAccessIsOpen = 0 } = {} } = directAuthenticationDMPStatus;
  
  return i_webAccessIsOpen === 1;
};

export const getPatientInfosFromState = (state, ins, vitaleIndex) => {
  const
    {
      dmpconnect: {
        [apiSections.VITALE_DATA_SECTION]  : {
          Patients = []
        } = {},
        [apiSections.INS_FROM_VITALE_CARD] : {
          [ins]: insiIdentity = {}
        } = {},
        [apiSections.FIND_PATIENTS_SECTION]: findPatients
      } = {}
    } = state;
  
  // cache TD0.4
  let accessibleDMP = getPatientFromAccessibleDMPsCache(state, ins);
  let cachedIdentity;
  if (accessibleDMP) {
    cachedIdentity = accessibleDMP.insiIdentity;
    if (cachedIdentity) {
      cachedIdentity = { ...cachedIdentity, Identity: fixQualifIdentityOid(cachedIdentity.Identity, getInsTypeFromNir(ins)) };
    }
  }
  
  // TDO.5
  let foundPatient;
  if (isReady(findPatients)) {
    foundPatient = findPatients.Patients.find(pat => {
      const { Ins: { s_ins = "", s_insType = "" } = {} } = pat;
      
      const patientIns = `${s_ins}${s_insType}`;
      
      return patientIns === ins;
    });
  }
  
  // Vitale
  let vitalePatient;
  if (vitaleIndex >= 0 && Patients && Patients.length > 0) {
    vitalePatient = Patients[vitaleIndex];
  }
  
  if (isReady(cachedIdentity) && cachedIdentity.i_insIdentityResult === 2) {
    return extractPatientInfoFromIdentity(cachedIdentity);
  } else if (isReady(insiIdentity) && insiIdentity.i_insIdentityResult === 2) {
    return extractPatientInfoFromIdentity(insiIdentity);
  } else if (accessibleDMP) {
    const
      {
        s_patientName,
        s_patientFirstBirthGiven,
        s_patientGivenName,
        s_patientBirthName,
        s_birthday
      } = accessibleDMP;
    return {
      name     : s_patientName || "",
      givenName: s_patientFirstBirthGiven || s_patientGivenName || "",
      birthday : s_birthday || "",
      birthName: s_patientBirthName || ""
    };
  } else if (vitalePatient) {
    const {
            s_name,
            s_given,
            s_birthdayYYYYMMDD,
            s_birthName
          } = vitalePatient;
    
    return {
      name     : s_name || "",
      givenName: s_given || "",
      birthday : s_birthdayYYYYMMDD || "",
      birthName: s_birthName || ""
    };
  } else if (foundPatient) {
    // TD05 result
    // {
    //   CivilStatus: {
    //     i_gender: 2,
    //       s_given: 'CELINE',
    //       s_name: 'INSFAMILLEQUATRE'
    //   },
    //   Ins: {
    //     s_ins: '203061212712750',
    //       s_insType: 'T'
    //   },
    //   i_matchingPercentage: 50,
    //     i_sex: 3,
    //   s_birthDay: '20030625',
    //   s_birthName: 'Maximop',
    //   s_city: 'NON_RENSEIGNE',
    //   s_postalCode: '00000'
    // },
    
    const
      {
        CivilStatus: {
          s_given,
          s_name
        } = {},
        s_birthName,
        s_birthDay,
        i_sex
      } = foundPatient;
    
    return {
      name     : s_name || "",
      givenName: s_given || "",
      birthday : s_birthDay || "",
      birthName: s_birthName || "",
      sex      : i_sex
    };
  }
  
  return undefined;
};

export const isPatientMinor = (state, ins, strict = false) => {
  const {
          userPreferences,
          dmpconnectConnectorConfig
        } = state;
  
  const patientInfos      = getPatientInfosFromState(state, ins);
  if (!patientInfos) {
    return false;
  }
  
  const { i_majorityAge } = getDmpParameterFromState(state);
  const minimumMinorAge   = Number(getConfigurationValue("minimumMinorAge", userPreferences));
  const debugMinorAge     = Number(getConfigurationValue("debugMinorAge", dmpconnectConnectorConfig));
  
  const { birthday }   = patientInfos;
  const birthdayMoment = moment.utc(birthday, ["YYYYMMDD"], true);
  const age            = moment.utc().diff(birthdayMoment, "years");
  const minorAge       = debugMinorAge || i_majorityAge;
  return (strict || age >= minimumMinorAge) && age < minorAge;
};

export const getSelectedPatientInfos = (
  directAuthenticationDMPStatus,
  vitaleCardSection,
  vitaleIndex
) => {
  let birthName      = "";
  let birthday       = "";
  let givenName      = "";
  let firstGivenName = "";
  let name           = "";
  let sex            = 1;
  let i_dmpStatus    = null;
  if (isReady(directAuthenticationDMPStatus)) {
    ({
      ExistingTestAnswer: {
        AdminData: {
          s_birthday              : birthday,
          s_patientGivenName      : givenName,
          s_patientFirstBirthGiven: firstGivenName,
          s_patientName           : name,
          s_patientBirthName      : birthName
        },
        i_sex    : sex,
        i_dmpStatus
      }
    } = directAuthenticationDMPStatus);
    
    if (i_dmpStatus !== dmpStatuses.DMPNotFound && i_dmpStatus !== dmpStatuses.DMPError) {
      return {
        name,
        givenName: firstGivenName || givenName,
        birthday,
        birthName,
        sex
      };
    }
  }
  
  if (isReady(vitaleCardSection) && !(birthday && givenName && firstGivenName && name)) {
    const { Patients }    = vitaleCardSection;
    const selectedPatient = Patients[vitaleIndex];
    if (selectedPatient) {
      ({
        s_name            : name,
        s_given           : givenName,
        s_birthdayYYYYMMDD: birthday,
        s_birthName       : birthName
      } = selectedPatient);
    }
  }
  
  return {
    name     : name || "",
    givenName: firstGivenName || givenName || "",
    birthday,
    birthName: birthName || ""
  };
};

export const getDirectAuthenticationStatusFromSection = (accessRights, section, ins) => {
  const {
          [`${ins}/${accessRights.psId}`]: psDirectAuthenticationDMPStatus = {},
          [`${ins}/${accessRights.esId}`]: esDirectAuthenticationDMPStatus = {}
        } = section;
  let directAuthenticationDMPStatus;
  
  const {
          ExistingTestAnswer: {
            i_userAuthorization: psAuthorization,
            ...restTest
          } = {},
          loading           : psLoading,
          error             : psError,
          ...restStatus
        } = psDirectAuthenticationDMPStatus;
  
  const emergency = psAuthorization === userAuthorizationStatuses.AuthorizationExpired
                    || psAuthorization === userAuthorizationStatuses.NoAuthorization;
  
  if (accessRights.authenticationType === authenticationTypes.AIR && !accessRights.airOnly) {
    const {
            ExistingTestAnswer: {
              i_userAuthorization: esAuthorization
            } = {},
            loading           : esLoading,
            error             : esError
          } = esDirectAuthenticationDMPStatus;
    
    let authorization = psAuthorization;
    if (!(
      psAuthorization === userAuthorizationStatuses.AuthorizationExist
      && esAuthorization === userAuthorizationStatuses.AuthorizationExist
    )) {
      authorization = userAuthorizationStatuses.NoAuthorization;
    }
    
    directAuthenticationDMPStatus = {
      ExistingTestAnswer: {
        i_userAuthorization: authorization,
        psAuthorization,
        esAuthorization,
        ...restTest
      },
      loading           : psLoading || esLoading,
      error             : psError || esError,
      ...restStatus
    };
  } else {
    directAuthenticationDMPStatus = psDirectAuthenticationDMPStatus;
  }
  
  return { ...directAuthenticationDMPStatus, showEmergency: emergency };
};
export const getDirectAuthenticationStatus            = (state, ins, remote = false) => {
  if (!ins) {
    return {};
  }
  
  const { accessRights }                                   = getAccessRightsProps(state);
  const { dmpconnectConnectorConfig: { airOnly = false } } = state;
  let section;
  if (remote) {
    ({
      dmpconnectRemote: {
        [apiSections.REMOTE_DIRECT_AUTHENTICATION_DMP_STATUS_SECTION]: section
      }
    } = state);
  } else {
    ({
      dmpconnect: {
        [apiSections.DIRECT_AUTHENTICATION_DMP_STATUS_SECTION]: section
      }
    } = state);
  }
  
  return getDirectAuthenticationStatusFromSection(accessRights, section, ins, airOnly);
};
export const getDirectAuthenticationStatusSection     = (state, ins) => {
  if (!ins) {
    return {};
  }
  
  const { accessRights }                                   = getAccessRightsProps(state);
  const { dmpconnectConnectorConfig: { airOnly = false } } = state;
  const {
          dmpconnect: {
            [apiSections.DIRECT_AUTHENTICATION_DMP_STATUS_SECTION]: section
          }
        }                                                  = state;
  
  return {
    dmpStatus: getDirectAuthenticationStatusFromSection(accessRights, section, ins, airOnly)
  };
};
export const getFormattedNames                        = (dmpDirectAuthenticationStatus) => {
  if (!isReady(dmpDirectAuthenticationStatus)) {
    return null;
  }
  
  const { ExistingTestAnswer } = dmpDirectAuthenticationStatus;
  const { AdminData }          = ExistingTestAnswer;
  const {
          s_patientGivenName, s_patientFirstBirthGiven, s_patientBirthName, s_patientName
        }                      = AdminData;
  return `${s_patientGivenName || s_patientFirstBirthGiven || ""} ${s_patientName || s_patientBirthName || ""}`;
};

export const isAuthorized = (directAuthenticationDMPStatus = {}) => {
  const {
          ExistingTestAnswer: {
            i_userAuthorization: authorization
          } = {}
        } = directAuthenticationDMPStatus;
  
  return authorization === userAuthorizationStatuses.AuthorizationExist;
};
